angular.module('FlexyBeautyApp.services')
    .factory('TaxMode', ['gettextCatalog', function (gettextCatalog) {

        let labelHt = gettextCatalog.getString("Hors taxe"),
            labelTtc = gettextCatalog.getString("TTC"),
            shortLabelHt = gettextCatalog.getString("HT"),
            shortLabelttc = gettextCatalog.getString("TTC");
        let taxMode = {
            HT:             {id: 'HT',      label: labelHt,        shortLabel : shortLabelHt},
            TTC:            {id: 'TTC',     label: labelTtc,       shortLabel : shortLabelttc}
        };

        taxMode.getTaxModeById = function(id){
            let modeToReturn = null;
            if(id === taxMode.HT.id){
                modeToReturn = taxMode.HT;
            }
            if(id === taxMode.TTC.id){
                modeToReturn = taxMode.TTC;
            }
            return modeToReturn
        };
        return taxMode;
    }])
    .factory('ZeroPercentTvaDateCorrection', function () {
        //TODO the constant ZeroPercentTvaDateCorrection is deprecated, This is a temporary solution to not impact the history
            const zeroPercentDateCorrection = {
            DATE : new Date(2019, 4, 1, 0, 0, 0),
            isBeforeCorrection : function(date){
                return date && date.getTime() < this.DATE.getTime();
            }
        };

        return zeroPercentDateCorrection;
    })
    .factory('TypeOfModification', ['gettextCatalog', function (gettextCatalog) {

        let modification = gettextCatalog.getString("Modification"),
            cancellation = gettextCatalog.getString("Annulation"),
            creation = gettextCatalog.getString("Création"),
            all = gettextCatalog.getString("Toutes les modifications");

        let typeOfModification = {
            ALL:                        {id: 'all',                     label: all},
            UPDATE:                     {id: 'update',                  label: modification},
            CANCELLATION:               {id: 'delete',                  label: cancellation},
            CREATION:                   {id: 'create',                  label: creation}
        };

        typeOfModification.values = function () {
            return [this.ALL, this.CREATION, this.CANCELLATION, this.UPDATE]
        };

        return typeOfModification;
    }]);


// WEBPACK FOOTER //
// ./js/services/views/planningPos/ConstantPos.js